import React from 'react';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import ReportCardSubheading from '/component/base/ReportCardSubheading';
import Text from '/component/base/Text';
import PremierOrderDetails from '/component/partial/PremierOrderDetails';
import {UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

interface ProjectedPremierVolumeReportContentProps {
  tt: (key: string, defaultValue: string) => string;
  recordData: {
    nextScheduledPremierOrder: {
      qv: number;
    };
  };
}

const ProjectedPremierVolumeReportContent: React.FC<
  ProjectedPremierVolumeReportContentProps
> = ({
  tt = (key: string, defaultValue: string) => defaultValue, // Default value for `tt`
  recordData = {nextScheduledPremierOrder: {qv: 0}}, // Default value for `recordData`
}: ProjectedPremierVolumeReportContentProps) => {
  const qv = recordData?.nextScheduledPremierOrder?.qv ?? 0;
  // const {
  //   nextScheduledPremierOrder: {qv},
  // } = recordData;

  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const updatedOrderType = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <>
      <ReportCardSubheading
        label={tt('label.premierOrder', `Scheduled ${updatedOrderType} Order`)}
        value={
          <>
            <FormattedNumber
              testID={UserProfileModal.scheduledPremier}
              value={qv}
              textVariant="large"
            />
            <Text variant="large"> {tt('label.qv', 'QV')}</Text>
          </>
        }
      />
      <PremierOrderDetails recordData={recordData} />
    </>
  );
};

// Exporting the component with `withTranslation` HOC
export default withTranslation('report.projectedPremierVolume.content')(
  ProjectedPremierVolumeReportContent,
);
